<template>
	<!-- 修改密码  -- 保存-->
	<div class="aboutYjBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">修改密码</p>
				</div>
			</div>
		</van-sticky>
		<div class="bcpasswordBox">
			<div>
				<span>新密码</span>
				<input type="text" placeholder="********" />
			</div>
			<div>
				<span class="newpassword">确认密码</span>
				<input type="text" placeholder="********"/>
			</div>
		</div>
		
		<div class="btn">
			<img src="../../assets/img/flower.png" alt="" class='flower'>
			<button>保存</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {}
		},
		methods: {
			back() {
				this.$router.push('/set')
			}
		}
	}
</script>

<style lang="less" scoped>
	.aboutYjBox{
		background-color: #f9f9f9;
		height: 100vh;
		overflow-y: scroll;
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;
		
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		.bcpasswordBox{
			padding-top: 20px;
			font-size: 30px;/*px*/
			div{
				display: flex;
				line-height: 80px;
				padding: 0 20px;
				margin-top:10px;
				background-color: #fff;
				input{
					flex:1;
					color: #aaaaaa;
					padding-left: 10px;
				}
				span{
					width: 20%;
				}
			}
		}
		.btn{
			text-align: center;
			margin-top: 180px;
			position: relative;
			.flower{
				position: absolute;
				top: -60px;
				left: 20%;
				width: 100px;
			}
			button{
				border: 0;
				line-height: 80px;
				font-size: 32px;/*px*/
				width: 90%;
				background-color: #FF4081;
				color:#fff;
				border-radius: 10px;
			}
		}
	}

</style>
